import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/site";

export const Services = ({ onQuote }) => {
  return (
    <section id="services" className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24 lg:py-32">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-16">
        <div>
          <span className="text-xs tracking-[0.25em] uppercase text-mh-orange font-bold">Nos prestations</span>
          <h2 className="mt-5 font-display font-bold text-4xl sm:text-5xl tracking-tight text-white max-w-2xl leading-[0.95]">
            Un savoir-faire complet en étanchéité
          </h2>
        </div>
        <p className="text-mh-slate max-w-sm">
          De la toiture terrasse aux murs enterrés, nous maîtrisons chaque technique
          pour protéger durablement votre bâti.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {SERVICES.map((s, i) => (
          <motion.article
            key={s.id}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: (i % 3) * 0.1, ease: [0.16, 1, 0.3, 1] }}
            className="group border border-mh-line bg-mh-bg2 clip-corner overflow-hidden flex flex-col"
            data-testid={`service-${s.id}`}
          >
            <div className="relative h-56 overflow-hidden">
              <img
                src={s.img}
                alt={s.title}
                className="w-full h-full object-cover img-arch transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-mh-bg2 to-transparent opacity-70" />
              <span className="absolute top-4 left-4 font-display font-black text-white/40 text-3xl">
                0{i + 1}
              </span>
            </div>
            <div className="p-7 flex flex-col flex-1">
              <h3 className="font-display font-bold text-xl text-white tracking-tight">{s.title}</h3>
              <p className="mt-3 text-sm text-mh-slate leading-relaxed flex-1">{s.desc}</p>
              <button
                onClick={onQuote}
                className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-mh-orange hover:gap-3 transition-all"
                data-testid={`service-cta-${s.id}`}
              >
                Demander un devis <ArrowUpRight size={16} />
              </button>
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
};
